/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Badge.vue.js?vue&type=template&id=7c4029fe!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=template&id=7c4029fe"
import script from "./Badge.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=script&lang=ts&setup=true"
export * from "./Badge.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Badge.vue.css?vue&type=style&index=0&id=7c4029fe&prod&lang=css!=!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./Badge.vue?vue&type=style&index=0&id=7c4029fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports